module.exports = __webpack_public_path__ + "assets/img/authority-5.29ca45ff.svg";